import { Fragment, useMemo } from 'react';

import { InfoOutlined } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { useFormikContext } from 'formik';

import { CissNumberField } from 'components/fields';
import { SubTitle } from 'components/text';
import { DreFormGroup } from 'pages/financeiro/dre/components/templates/DreFormGroup';
import { DreFormRow } from 'pages/financeiro/dre/components/templates/DreFormRow';
import { DreForm, DreVendasConfiguracao } from 'pages/financeiro/dre/types';
import { getLines } from 'pages/financeiro/dre/utils';
import { brlPrice } from 'util/format';

export function DreFormVendas() {
    const { values } = useFormikContext<DreForm>();

    return useMemo(
        () => (
            <DreFormGroup label="Vendas" id="1">
                {values.dreMercadologicaVendas.map((vendas, index) => (
                    <Fragment key={vendas.dreMercadologicaGrupoExibicao.idDreMercadologicaGrupoExibicao}>
                        <SubTitle
                            sx={{ m: 0 }}
                            id={`1_${vendas.dreMercadologicaGrupoExibicao.idDreMercadologicaGrupoExibicao}`}
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <strong>{vendas.dreMercadologicaGrupoExibicao.dsDreMercadologicaGrupoExibicao}</strong>
                                    <span>{brlPrice(vendas.dreMercadologicaGrupoExibicao.vlTotal)}</span>
                                </Box>
                            }
                        />

                        {Object.entries(getLines<DreVendasConfiguracao>(vendas.dreMercadologicaValor, 'dreMercadologicaConfigVenda')).map(
                            ([line, configuracoes]) => (
                                <DreFormRow key={line}>
                                    {configuracoes.map((config) => {
                                        const prefix = `dreMercadologicaVendas[${index}].dreMercadologicaValor[${config.index}]`;
                                        const tooltip = config.dreMercadologicaConfigVenda.dsObservacao;

                                        return (
                                            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1.5 }} key={prefix}>
                                                <CissNumberField
                                                    disabled
                                                    inputType="decimal"
                                                    value={config.vlTotal}
                                                    name={`${prefix}.vlTotal`}
                                                    label={`${config.dreMercadologicaConfigVenda.dsNomeExibicao} (R$)`}
                                                />

                                                <CissNumberField
                                                    disabled
                                                    inputType="decimal"
                                                    value={config.vlTotalAjustado}
                                                    name={`${prefix}.vlTotalAjustado`}
                                                    label={`Valor total ${config.dreMercadologicaConfigVenda.dsNomeExibicao} (R$)`}
                                                />

                                                {tooltip && (
                                                    <Tooltip title={tooltip}>
                                                        <InfoOutlined />
                                                    </Tooltip>
                                                )}
                                            </Box>
                                        );
                                    })}
                                </DreFormRow>
                            ),
                        )}
                    </Fragment>
                ))}
            </DreFormGroup>
        ),
        [values.dreMercadologicaVendas],
    );
}
